(ns ballot-scout-v2-frontend.dashboard.views
  (:require
   [ballot-scout-v2-frontend.dashboard.views.current-ballot-location :as locs]
   [ballot-scout-v2-frontend.dashboard.views.days-in-service :as days]
   [ballot-scout-v2-frontend.dashboard.views.noty-stats :as noty]
   [ballot-scout-v2-frontend.dashboard.views.where-are-ballots :as where]
   [ballot-scout-v2-frontend.events :as events]
   [ballot-scout-v2-frontend.request-helpers :as request-helpers]
   [ballot-scout-v2-frontend.subs :as subs]
   [re-frame.core :as rf]))

(defn dashboard-container []
  ; TODO: make an init function?
  [:div {:class "component-list"}
   [where/ballots-by-status]
   [locs/map-view]
   [noty/noty-stats-view]
   [days/days-in-service-view]])

(defn jurisdiction-page []
  (let [current-jurisdiction-slug @(rf/subscribe [::subs/current-jurisdiction-slug])
        current-jurisdiction @(rf/subscribe [::subs/current-jurisdiction])
        fetch-jurisdiction-error @(rf/subscribe [::request-helpers/failed-request
                                                 [::events/fetch-jurisdiction current-jurisdiction-slug]])]
    (if current-jurisdiction
      [:div {:class "home-view"}
       [dashboard-container]]
      (if (some? fetch-jurisdiction-error)
        (:status-text fetch-jurisdiction-error)
        "Loading Partner Data"))))

(defn partner-page []
  (let [current-partner-slug @(rf/subscribe [::subs/current-partner-slug])
        current-partner @(rf/subscribe [::subs/current-partner])
        fetch-partner-error @(rf/subscribe [::request-helpers/failed-request
                                            [::events/fetch-partner current-partner-slug]])]
    (if current-partner
      [:div {:class "home-view"}
       [dashboard-container]]
      (if (some? fetch-partner-error)
        (:status-text fetch-partner-error)
        "Loading Partner Data"))))
